module.exports = __webpack_public_path__ + "static/media/mm.a646bac3.svg";